/* ModVilla storefront intent signals.
 *
 * 9 Aug 2026: the currency-normalisation half of this file was REMOVED. It walked every text
 * node under #site-main rewriting a legacy rupee prefix to "₹", re-running on a MutationObserver for 12 seconds,
 * and it was the fourth of four layers doing the same job (the other three were Liquid `replace`
 * filters in theme-money.liquid, theme-money-format.liquid and product-price.liquid, all now
 * reverted).
 *
 * The actual cause is Shopify's shop-level money format, which still emits a legacy prefix. That is one
 * field in Settings > Store details > Currency formatting, and changing it fixes the storefront,
 * cart, checkout, order emails and every installed app at once, rather than only the surfaces the
 * theme happens to render. Standing rule from the founder: if it can be done in admin, do it in
 * admin, not in the theme.
 *
 * For the record, the observer was NOT a performance problem: measured on the review theme a full
 * text walk was 0.2ms and the collection page settled to zero childList mutations. It was removed
 * for being unnecessary, not for being slow.
 *
 * What remains here is the storefront intent instrumentation, which has no admin equivalent.
 */
(function () {
  "use strict";

  function pushEvent(name, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, mv: detail || {} });
    } catch (error) {}
  }

  function init() {
    document.addEventListener("submit", function (event) {
      var form = event.target.closest && event.target.closest('form[action*="/search"]');
      if (!form) return;
      var input = form.querySelector('input[name="q"]');
      pushEvent("mv_search_submit", {
        query: input ? String(input.value || "").trim() : "",
        path: location.pathname
      });
    });

    document.addEventListener("click", function (event) {
      var link = event.target.closest && event.target.closest("a[href]");
      if (!link) return;
      var href = link.getAttribute("href") || "";
      if (href.indexOf("wa.me/") > -1) {
        pushEvent("mv_concierge_click", { path: location.pathname, label: (link.textContent || "").trim().slice(0, 120) });
      } else if (href.indexOf("/pages/build-your-own") > -1) {
        pushEvent("mv_builder_entry_click", { path: location.pathname });
      } else if (link.closest(".productgrid--item") && href.indexOf("/products/") > -1) {
        // Scoped to real product links so swatch, quick-add and wishlist controls inside the
        // card are not counted as card clicks.
        pushEvent("mv_product_card_click", { path: location.pathname, product_url: href.split("?")[0] });
      }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
